module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('gestion-salas-reuniones-editar', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    attrs: {
      "sala": _vm.salaSeleccionada
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  }) : _vm._e()], 1), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.eliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar la sala " + _vm._s(_vm.salaSeleccionada.nombre) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Administrador de Salas")])]), _c('div', {
    staticClass: "filtros-container"
  }, [_c('div', {
    staticClass: "text-right acciones"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "table-lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Sala")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.shadowList), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      },
      on: {
        "dblclick": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'sala: ' + o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])])])])
  }), 0)], 1) : _vm._e()]), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No hay registros")])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-170fa610","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Gestion_Salas_Reuniones.vue
// module id = 831
// module chunks = 0